var $, addedWidgets, body, bodyheight, carouselIsPlaying, checkScroll, checkSliders, clists, equalise, fi, fic, fullimgs, html, jQuery, mcm, mmutationObserver, mo, riot, sliders, topbutton, updateImage;

window.riot = riot = require('riot');

require('riot-kit/lib/slideshow');
require("riot-kit/lib/img_loader");
require('riot-kit/lib/form');
require('riot-kit/lib/twitter');
require('riot-kit/lib/modal');
require('riot-kit/lib/form');
require('riot-kit/lib/ecommerce');
require('riot-kit/lib/pagination');
require('riot-kit/lib/dateformat');
require('riot-kit/lib/booking-calendar');
require('riot-kit/lib/dropdown');
require('riot-kit/lib/gmap');
require('riot-kit/lib/auth/forgot-password');
require('riot-kit/lib/tabs');
require('./tags/loginbar.tag');
require('./tags/ecommercebar.tag');
require('./tags/navigation.tag');
require('./tags/mydetails.tag');
require('./tags/mypassword.tag');
require('./tags/signup.tag');
require('./tags/tags-input.tag');
require('./tags/comments_input.tag');
require('./tags/comments_output.tag');
require('./tags/recaptcha.tag');
require('./tags/pricetag.tag');
require('./libs/slideshow.coffee');
require('./tags/counter.tag');
require('./tags/gmap.tag');
require('./tags/duomap.tag');
require('./tags/availability-cal.tag');
require('./tags/auth/signin.tag');
require('./tags/auth/signup.tag');
require('./tags/profile.tag');
require('./tags/productfilter.tag');
require('smoothscroll-polyfill').polyfill();
require('./tags/faqs.tag');
require('./tags/mailchimp.tag');
require('./tags/siemens-register.tag');

$ = jQuery = window.jQuery = window.$ = require("jquery");

require('owl.carousel');

let isEditMode = window.location.search.match(/editmode=true/)
let componentCss = ""
import {component} from "duo-kit"
import Panel from "./components/panel.svelte"
component({component:Panel,tagname:"duo-panel",href:componentCss,shadow:isEditMode});

addedWidgets = [];

window.verticalWidgetCallback = function() {
  addedWidgets.push("full-page-widget");
  if (!document.querySelector("#full-page-widget")) {
    return;
  }
  return window.verticalWidget('full-page-widget', {
    store: 'hmkdirect-com',
    primaryClr: '#f47e27',
    layout: 'fullWidth',
    height: 500,
    numReviews: 21
  });
};

window.reviewsBadgeCallback = function() {
  addedWidgets.push("badge-250");
  if (!document.querySelector("#badge-250")) {
    return;
  }
  return window.reviewsBadge('badge-250', {
    store: 'hmkdirect-com',
    primaryClr: '#3fa9f5',
    neutralClr: '#3fa9f5',
    starsClr: '#fff',
    textClr: '#fff'
  });
};

if (addedWidgets.indexOf("full-page-widget") === -1 && window.verticalWidget) {
  window.verticalWidgetCallback();
}

if (addedWidgets.indexOf("badge-250") === -1 && window.reviewsBadge) {
  window.reviewsBadgeCallback();
}

riot.mount('*');

document.addEventListener('duocms:updated', function() {
  return riot.mount('slideshow,gmap');
});

topbutton = document.querySelector('.topbutton');

topbutton.addEventListener('click', function() {
  return document.querySelector('#page-top').scrollIntoView({
    behavior: 'smooth'
  });
});

[].slice.call(document.querySelectorAll(".nav.navbar-nav.navbar-right a")).forEach(function(link) {
  var linkpath;
  linkpath = "/" + link.href.split("/").slice(3).join("/");
  if (window.location.pathname === linkpath) {
    return link.className += " active";
  }
});

[].slice.call(document.querySelectorAll(".subnav-child .expandable span")).forEach(function(subnav) {
  var linkpath;
  if (subnav) {
    if (subnav.parentNode.href) {
      linkpath = "/" + subnav.parentNode.href.split("/").slice(3).join("/");
      if (window.location.pathname.match(linkpath)) {
        subnav.parentNode.parentNode.className += " show";
      }
    }
    return subnav.addEventListener("click", function(event) {
      var tg;
      event.preventDefault();
      event.stopPropagation();
      tg = event.target.parentNode.parentNode;
      if (tg != null ? tg.className.match(/show/) : void 0) {
        return tg.className = tg.className.replace(/ ?show ?/, "");
      } else {
        return tg.className += " show";
      }
    });
  }
});

mmutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

mo = new mmutationObserver(function(mutations) {
  var m, mutation, results;
  m = 0;
  results = [];
  while (m < mutations.length) {
    mutation = mutations[m];
    if (mutation.type === "attributes" && mutation.target.className.match(/navshowing/)) {
      [].slice.call(document.querySelectorAll(".navbar-nav li")).forEach(function(subnav) {
        return subnav.addEventListener('click', function(e) {
          var subsecs;
          if (subnav.getAttribute('riot-tag') === "dropdown" && subnav.className.match(/open/)) {
            e.preventDefault();
            subnav.querySelector('a,i').addEventListener('click', function(e) {
              return window.location.href = subnav.querySelector('a').href;
            });
            subsecs = subnav.querySelectorAll('.subnav a');
            if (subsecs.length > 0) {
              return [].slice.call(subsecs).map((function(_this) {
                return function(sec) {
                  return sec.addEventListener('click', function(e) {
                    return window.location.href = sec.href;
                  });
                };
              })(this));
            }
          }
        });
      });
    }
    results.push(m++);
  }
  return results;
});

mo.observe(document.querySelector('body'), {
  attributes: true
});

[].slice.call(document.querySelectorAll("link[media=none]")).forEach(function(stl) {
  return stl.setAttribute("media", "all");
});

[].slice.call(document.querySelectorAll('input')).forEach(function(input) {
  var ref;
  if ((ref = input.getAttribute("name")) != null ? ref.match(/^duoreform/) : void 0) {
    return input.setAttribute("style", "display:none");
  }
});

checkScroll = function() {
  return [].forEach.call(fullimgs, function(fimg, index) {
    var fi_height, fi_top, target;
    fi_top = fimg.getBoundingClientRect().top;
    fi_height = fimg.getBoundingClientRect().height;
    target = window.innerHeight - fi_height;
    if (fi_top < target) {
      if (carouselIsPlaying[index] !== true) {
        $(clists[index]).trigger('play.owl.autoplay');
      }
      return carouselIsPlaying[index] = true;
    }
  });
};

checkSliders = function() {
  return [].forEach.call(sliders, function(slider) {
    var s_top, target;
    s_top = slider.getBoundingClientRect().top;
    target = window.innerHeight - 100;
    if (s_top < target) {
      return slider.className = slider.className.replace(/ ?vis ?/, '') + ' vis';
    }
  });
};

equalise = function() {
  var h, img, src;
  h = fic.clientHeight;
  fi.setAttribute('style', "height:" + h + "px");
  img = fi.querySelector('.img-responsive');
  src = img.getAttribute('src');
  img.parentNode.setAttribute('style', 'position:absolute;height:100%;width:100%;top:0;left:0;right:0;bottom:0;background-image:url("' + src + '");background-size:cover;background-position:center center;');
  return img.setAttribute('style', 'display:none');
};

updateImage = function(e) {
  var active, img, prev, prnt;
  img = e.currentTarget.querySelectorAll('.owl-item .item')[e.item.index].getAttribute('data-img');
  if (img === "undefined") {
    img = '';
  }
  prnt = $(e.currentTarget).closest('.band').children('.fullimage');
  prnt = $(e.currentTarget).closest('.band').children('.fullimage');
  active = prnt.children('.owlimg-active');
  prev = prnt.children('.owlimg-prev');
  prev.removeClass('fadeout');
  active.css('background-image', 'url(' + img + ')');
  active.addClass('fadein');
  if (!img || typeof img === 'undefined' || img === 'undefined') {
    prev.addClass('fadeout');
  }
  return setTimeout(function() {
    prev.css('background-image', 'url(' + img + ')');
    return active.removeClass('fadein');
  }, 1500);
};

clists = document.querySelectorAll('.dl_panel');

fullimgs = document.querySelectorAll('.fullimage');

sliders = document.querySelectorAll('.slidein');

carouselIsPlaying = [];

mcm = document.querySelector('.mailchimp-modal');

if (mcm) {
  mcm.className = mcm.className.replace(/ ?loading ?/, '');
}

checkSliders();

['scroll', 'load', 'resize'].forEach(function(type) {
  if (fullimgs.length) {
    window.addEventListener(type, checkScroll);
  }
  if (sliders.length) {
    return window.addEventListener(type, checkSliders);
  }
});

body = document.body;

html = document.documentElement;

bodyheight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

if (bodyheight <= window.innerHeight) {
  checkSliders();
}

setTimeout(function() {
  window.scrollTo(window.scrollX, window.scrollY + 1);
  window.scrollTo(window.scrollX, window.scrollY - 1);
  return document.querySelector('#page-top').scrollIntoView({
    behavior: 'smooth'
  });
}, 300);

fi = document.querySelector('.fullimage');

fic = document.querySelector('.fullimage_check');

if (fi && fic) {
  equalise();
}

if (!body.className.match(/editmode/)) {
  // console.log("NOT EDITING");
  [].forEach.call(clists, function(clist) {
    $(clist).addClass('owl-carousel');
    $(clist).owlCarousel({
      items: 1,
      autoplay: true,
      autoplayTimeout: 6000,
      loop: true,
      dots: true,
      autoplayHoverPause: true,
      onInitialized: updateImage,
      dotsContainer: $(clist).closest('.band').find('.owl-dots-outer')
    });
    $(clist).on('changed.owl.carousel', updateImage);
    return $(clist).trigger('stop.owl.autoplay');
  });
}

// ---
// generated by coffee-script 1.9.2